<template>
    <div>
        <app-page-header></app-page-header>
        <v-container  grid-list-xl class="box">
            <v-form id="form_rfid_user" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap align-center justify-center fill-height>
                    <v-flex xs12 sm12 md12 lg10 xl10>
                        <v-card id="form_card">
                            <v-card-title>
                                <v-icon left>mdi-clipboard-account</v-icon>
                                    <span class="subtitle-1 font-weight-regular application--card--title">Ustvari zapis o plačilu članarine</span>
                                    <v-spacer></v-spacer>
                                <!--<v-btn icon @click="card1 = !card1">
                                    <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>-->
                            </v-card-title>
                            <v-divider v-show="card1"></v-divider>
                            
                            <v-card-text v-show="card1">
                                <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                                <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                                <br v-if="apiValidationMessages.length > 0 || apiMessages.length > 0 || apiErrorMessages.length > 0">

                                <v-layout row justify-center v-bind="columnBinding">
                                    <v-flex xs12 md4 align-content-center>
                                        <v-subheader class="pb-5"><strong>Izberi leto za plačilo</strong></v-subheader>
                                    </v-flex>
                                    <v-flex xs12 md8 align-content-center>
                                        <v-select
                                            :items="years"
                                            label="Izberi leto"
                                            v-model="membershipFeePaymentYear"
                                            persistent-hint
                                            clearable
                                            outlined
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <div style="min-height:0px"></div>
                            </v-card-text>
                            

                            <!-- podatki o plačniku -->
                            <!--<v-divider></v-divider>-->
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-account-plus-outline</v-icon>
                                <v-toolbar-title class="body-2">Izberi plačnika članarine</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card2 = !card2">
                                    <v-icon>{{ card2 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card2">
                                <!-- backend validation messages -->
                                <form-validation-messages :messages="apiValidationMessages"></form-validation-messages>
                                <form-submit-messages :messages="apiMessages" :errorMessages="apiErrorMessages"></form-submit-messages>
                                <br v-if="apiValidationMessages.length > 0 || apiMessages.length > 0 || apiErrorMessages.length > 0">

                                <div style="min-height:10px"></div>

                                <v-alert
                                text
                                outlined
                                color="deep-orange"
                                icon="mdi-information"
                                >
                                Iz spodnjega seznama izberite kdo je plačnik članarine posameznega ali večih članov.

                                </v-alert>
                                <div style="min-height:10px"></div>
                                <members-data-table
                                :settings="dataTableSettings1"
                                :queryParameters="queryParameters"
                                ></members-data-table> 
                                <div style="min-height:10px"></div>

                            </v-card-text>

                            <!-- člani -->
                            <v-divider></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-account-plus-outline</v-icon>
                                <v-toolbar-title class="body-2">Izberi člane</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card3 = !card3">
                                    <v-icon>{{ card3 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card3">
                                <div style="min-height:10px"></div>

                                <v-alert
                                text
                                outlined
                                color="deep-orange"
                                icon="mdi-information"
                                >
                                Iz spodnjega seznama izberite člane, za katere želite izvesti plačilo članarine.

                                </v-alert>
                                <div style="min-height:10px"></div>
                                <members-data-table
                                :settings="dataTableSettings2"
                                :queryParameters="queryParameters"
                                ></members-data-table> 
                                <div style="min-height:10px"></div>
                            </v-card-text>

                            <!-- podatki o plačilu -->
                            <v-divider v-if="membershipFeePaymentYear !== null && selectedMembers.length > 0 && selectedPayer.length > 0"></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                                v-if="membershipFeePaymentYear !== null && selectedMembers.length > 0 && selectedPayer.length > 0"
                            >   
                                <v-icon left>mdi-file-document-outline</v-icon>
                                <v-toolbar-title class="body-2">Povzetek za plačilo članarine</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card4 = !card4">
                                    <v-icon>{{ card4 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider v-if="membershipFeePaymentYear !== null && selectedMembers.length > 0 && selectedPayer.length > 0"></v-divider>
                            <v-card-text v-if="membershipFeePaymentYear !== null && selectedMembers.length > 0 && selectedPayer.length > 0" v-show="card4">
                                <payment-info :data="paymentInfoData"></payment-info>
                                <br v-if="paymentDone"> 
                                <v-alert v-if="paymentDone"
                                    outlined
                                    type="success"
                                    text
                                    dense
                                    dismissible
                                    >
                                    Plačilo članarine je bilo uspešno zavedeno.
                                    </v-alert>
                            </v-card-text>

                            <v-divider></v-divider>
                            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                                <v-btn block outlined style="margin-bottom:10px;" @click="submitForm()" color="success" :disabled="loading || !enablePaymentBtn || paymentDone"><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                <v-btn block outlined style="margin-bottom:10px;" @click="clearForm()" color="warning"><v-icon left>mdi-refresh</v-icon>{{ cancelText }}</v-btn>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-btn @click="submitForm()" color="success" text :disabled="loading || !enablePaymentBtn || paymentDone "><v-icon left>mdi-arrow-right</v-icon>{{ btnSubmitFormTitle }}</v-btn>
                                <v-btn @click="clearForm()" color="warning" text><v-icon left>mdi-refresh</v-icon>{{ cancelText }}</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-form>

            <data-table-toggle-columns
            :dataTableId="dataTableSettings1.id"
            :columns="dataTableSettings1.headers"
            :dataTableColumnsMenuId="dataTableSettings1.eventBus.toggleColumnsId"
            ></data-table-toggle-columns>

            <data-table-toggle-columns
            :dataTableId="dataTableSettings2.id"
            :columns="dataTableSettings2.headers"
            :dataTableColumnsMenuId="dataTableSettings2.eventBus.toggleColumnsId"
            ></data-table-toggle-columns>

            <membership-fee-payment></membership-fee-payment>
        </v-container>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'
import { formatDate, randomPinNumber, getCurrentDate } from '@/helpers/utilities.js'
const FormValidationMessages = () => import('@/components/FormValidationMessages.vue')
const FormSubmitMessages = () => import('@/components/FormSubmitMessages.vue')
const MembersDataTable = () => import('@/components/MembersDataTable.vue')
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')
const PaymentInfo = () => import('@/components/PaymentInfo.vue')
const MembershipFeePayment = () => import('@/components/MembershipFeePayment.vue')

export default {
    components: {
        FormValidationMessages,
        FormSubmitMessages,
        MembersDataTable,
        DataTableToggleColumns,
        PaymentInfo,
        MembershipFeePayment
    },

    data: () => ({
        valid: true,
        form: true,
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,

        loading: false,
        storeItemLoading: false,

        membershipFeePaymentYear: null,
        selectedPayer: [],
        selectedMembers: [],
        selectedMembersFiltered: [],
        paymentDone: false,


        postcodes: [],
        gender: [],
        memberTypes: [],
        memberClassifications: [],
        withdrawalTypes: [],
        years: [],

        backendMessages: [],
        backendErrorMessages: [],
        backendValidationMessages:[],

        cancelText: "Prekliči",

        dataTableSettings1: {
            id: 'dtEvents1',
            title: 'Seznam članov',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                // { text: "ID", value: "id", class: "text-xs-left", visibility: true},
                { text: "Ime in priimek", value: "name", class: "text-xs-left", visibility: true},
                { text: "Naslov", value: "full_address", class: "text-xs-left", visibility: true},
                { text: "Kraj", value: "town", class: "text-xs-left", visibility: true},
                { text: "Pošta", value: "postcode", class: "text-xs-right", align:"right", visibility: true},
                //{ text: "Aktiven član", value: "membership_active", class: "text-xs-right", align: "right", visibility: true},
                //{ text: "Spol", value: "gender", class: "text-xs-left", visibility: true},
                //{ text: "GSM", value: "phone_number", class: "text-xs-left", visibility: true},
                //{ text: "Email", value: "email", class: "text-xs-left", visibility: true},
                // { text: "Davčna številka", value: "tax_number", class: "text-xs-left", visibility: true},
                //{ text: "Članarina", value: "membership_fee", class: "text-xs-left", visibility: true},
                //{ text: "Tip člana", value: "member_type", class: "text-xs-left", visibility: true},
                //{ text: "Vrsta člana", value: "member_classification", class: "text-xs-left", visibility: true},
                // { text: "Datum pridružitve", value: "date_of_registration_formatted", class: "text-xs-left", visibility: true},
                // { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true, permissions:['sobec-create-member', 'sobec-update-member', 'sobec-delete-member', 'sobec-view-member']},
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: 'sobec/members',
            editItem: {
                route: 'edit_member',
                routeParameterValue: 'uuid'
            },
            viewItem: {
                route: 'view_member',
                routeParameterValue: 'uuid'
            },
            deleteItem: {
                vuexAction: 'DELETE_MEMBER',
                replaceStrWithColumnValue: 'name',
                confirmationText : "Sta prepričani da želite odstraniti člana {str_to_replace} ?",
                dialogConfirmSuccessText: 'Član {str_to_replace} je bil uspešno odstranjen.',
                dialogConfirmFailText: 'Pri odstranjevanju člana {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: false,
                    addNewRoute: 'add_member',
                    toggleColumns: true
                }
            },

            selectItems: {
                enabled: true,
                singleSelect: true
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_members_1',
                totalItems : {
                    event: ''
                },
                search: 'dt-members-search-1',
                toggleColumnsId: 'toggle-members-list-columns-1',
                selectedItems: 'dt-members-select-items-1',
                removeSelectedItems: 'dt-members-remove-selected-item-1'
            }


        },

        dataTableSettings2: {
            id: 'dtEvents2',
            title: 'Seznam članov',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                // { text: "ID", value: "id", class: "text-xs-left", visibility: true},
                { text: "Ime in priimek", value: "name", class: "text-xs-left", visibility: true},
                { text: "Naslov", value: "full_address", class: "text-xs-left", visibility: true},
                { text: "Kraj", value: "town", class: "text-xs-left", visibility: true},
                { text: "Pošta", value: "postcode", class: "text-xs-left", visibility: true},
                //{ text: "Spol", value: "gender", class: "text-xs-left", visibility: true},
                //{ text: "GSM", value: "phone_number", class: "text-xs-left", visibility: true},
                //{ text: "Email", value: "email", class: "text-xs-left", visibility: true},
                // { text: "Davčna številka", value: "tax_number", class: "text-xs-left", visibility: true},
                { text: "Pošta", value: "postcode", class: "text-xs-left", visibility: true},
                { text: "Aktiven član", value: "membership_active", class: "text-xs-left", visibility: true},
                { text: "Članarina", value: "membership_fee", class: "text-xs-right", align: "right", visibility: true},
                //{ text: "Tip člana", value: "member_type", class: "text-xs-left", visibility: true},
                //{ text: "Vrsta člana", value: "member_classification", class: "text-xs-left", visibility: true},
                // { text: "Datum pridružitve", value: "date_of_registration_formatted", class: "text-xs-left", visibility: true},
                // { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true, permissions:['sobec-create-member', 'sobec-update-member', 'sobec-delete-member', 'sobec-view-member']},
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: 'sobec/members',
            editItem: {
                route: 'edit_member',
                routeParameterValue: 'uuid'
            },
            viewItem: {
                route: 'view_member',
                routeParameterValue: 'uuid'
            },
            deleteItem: {
                vuexAction: 'DELETE_MEMBER',
                replaceStrWithColumnValue: 'name',
                confirmationText : "Sta prepričani da želite odstraniti člana {str_to_replace} ?",
                dialogConfirmSuccessText: 'Član {str_to_replace} je bil uspešno odstranjen.',
                dialogConfirmFailText: 'Pri odstranjevanju člana {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: false,
                    addNewRoute: 'add_member',
                    toggleColumns: true
                }
            },

            selectItems: {
                enabled: true,
                singleSelect: false
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_members_2',
                totalItems : {
                    event: ''
                },
                search: 'dt-members-search-2',
                toggleColumnsId: 'toggle-members-list-columns-2',
                selectedItems: 'dt-members-select-items-2',
                removeSelectedItems: 'dt-members-remove-selected-item-2'
            }


        }



    }),

    watch: {
        paymentDone(value) {
            //window.console.log("payment_done: ", value)
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        apiMessages() {
            return this.backendMessages;
        },

        apiErrorMessages() {
            return this.backendErrorMessages 
        },

        apiValidationMessages() {
            return this.backendValidationMessages
        },

        btnSubmitFormTitle() {
            if(this.$vuetify.breakpoint.smAndDown) {
                return 'Shrani'
            }

            return 'Shrani plačilo'
        },

        queryParameters() {
            return {

            }
        },

        paymentInfoData() {
            /*let dt = {
                year: this.membershipFeePaymentYear,
                selectedPayer: this.selectedPayer,
                selectedMembers: this.selectedMembers
            }
            */

            //window.console.log(dt)

            return {
                year: this.membershipFeePaymentYear,
                selectedPayer: this.selectedPayer,
                selectedMembers: this.selectedMembers
            }
        },

        enablePaymentBtn() {
            if(this.membershipFeePaymentYear !== null && this.membershipFeePaymentYear !== '' && this.selectedPayer.length > 0 && this.selectedMembers.length > 0) {
                return true
            }

            return false
        }
    },

    methods: {
        submitForm() {
            let vm = this
            let members = [];

            vm.selectedMembers.forEach(member => {
                let memberItem = {}
                memberItem.member_id = member.id,
                memberItem.member_uuid = member.uuid
                memberItem.membership_fee_year = vm.membershipFeePaymentYear
                memberItem.membership_fee_id = member.membership_fee_id
                memberItem.membership_fee = member.membership_fee

                members.push(memberItem)
            })

            let paymentData = {
                payer_id: vm.selectedPayer[0].id,
                payer_uuid: vm.selectedPayer[0].uuid,
                data: members
            }

            //window.console.log(paymentData)
            EventBus.$emit('MEMBERSHIP_FEE_PAYMENT_DIALOG', paymentData);
        },

        clearForm() {
            let vm = this
            this.membershipFeePaymentYear = null
            this.selectedPayer = []
            this.selectedMembers = []

            const d = new Date();
            let year = d.getFullYear();
            vm.membershipFeePaymentYear = year

            this.paymentDone = false
            this.cancelText = "Prekliči"
            EventBus.$emit(this.dataTableSettings1.eventBus.removeSelectedItems, null)
            EventBus.$emit(this.dataTableSettings2.eventBus.removeSelectedItems, null)

            setTimeout(() => {
                    vm.$vuetify.goTo('#form_card', {
                        duration: 1000,
                        offset: 0,
                        easing: 'easeInOutCubic'
                    })
                }, 200)
        },
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
    },
    
    mounted() {
        var vm = this
        vm.$store.commit('SET_PROGRESS', true)
        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //(window.console.log(response.data)
            vm.gender = response.data.gender
            vm.postcodes = response.data.postcodes
            vm.memberTypes = response.data.memberTypes
            vm.memberClassifications = response.data.memberClassifications
            vm.withdrawalTypes = response.data.withdrawalTypes
            vm.years = response.data.years

            setTimeout(() => {
                const d = new Date();
                let year = d.getFullYear();
                vm.membershipFeePaymentYear = year
            }, 250)
        })
        .catch(error => {
            window.console.error("### ERROR Users.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })

        EventBus.$on(this.dataTableSettings1.eventBus.selectedItems, (data) => {
            //window.console.log("Plačnik članarine")
            //window.console.log(data)
            vm.selectedPayer = data
        })

        EventBus.$on(this.dataTableSettings2.eventBus.selectedItems, (data) => {
            //window.console.log("Člani")
            //window.console.log(data)
            vm.selectedMembers = data
        })

        EventBus.$on('MEMBERSHIP_FEE_PAYMENT_CONFIRMATION', (data) => {
            ////window.console.log("Membership Fee Payment Confirmation")
            //window.console.log(data)
        })

        EventBus.$on('MEMBERSHIP_FEE_PAYMENT_DIALOG_CLOSE', (data) => {
            //window.console.log("Membership Fee Payment Dialog Close")
            //window.console.log(data)
            if(data.paymentDone) {
                this.paymentDone = true
                this.cancelText = "Zaključi plačilo"
            } else {
                this.paymentDone = false
            }
        })
    },

    beforeDestroy() {
        EventBus.$off(this.dataTableSettings1.eventBus.selectedItems);
        EventBus.$off(this.dataTableSettings2.eventBus.selectedItems);
        EventBus.$off('MEMBERSHIP_FEE_PAYMENT_CONFIRMATION');
        EventBus.$off('MEMBERSHIP_FEE_PAYMENT_DIALOG_CLOSE')
    },

    destroyed() {

    }
}

</script>

<style scoped>

</style>